import { render, staticRenderFns } from "./modal-board-update.vue?vue&type=template&id=058ebfff&"
import script from "./modal-board-update.vue?vue&type=script&lang=js&"
export * from "./modal-board-update.vue?vue&type=script&lang=js&"
import style0 from "./modal-board-update.vue?vue&type=style&index=0&id=058ebfff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports